/**
 * Main file used to import all global JavaScript
 * Non global JavaScript and CSS are added to clientAppEntry.json
 */

import { setup } from './features/global';

setup();
